import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import { AnswerTypes } from 'types';

import Header from 'components/Header';

import hexToRGB from 'utils/hexToRgb';
import saveAnswersInSessionStorage from 'utils/saveAnswersInSessionStorage';
import sendAnalyticsEvent from 'utils/sendAnalyticsEvent';

let timerId: ReturnType<typeof setTimeout>;
const QuestionScreen: FC<AnswerTypes> = (props) => {
    const {
        lengthOnboarding,
        logoUrl,
        title,
        answers,
        handleSwitchToNextScreen,
        id,
        question,
        handleSwitchToPrevScreen,
        logoLink,
    } = props;
    const [activeAnswer, setActiveAnswer] = useState('');
    const [isAnimate, setIsAnimate] = useState(true);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const quizScreenFromUrl = Number(params.get('screen'));

    const themColor = document.documentElement.style.getPropertyValue('--them-color');

    const handleClick = (answer: string) => {
        setActiveAnswer(answer);
        saveAnswersInSessionStorage({ id, question, selectedAnswers: [answer] });
        clearTimeout(timerId);
        setIsAnimate(false);

        timerId = setTimeout(() => {
            handleSwitchToNextScreen();
            sendAnalyticsEvent({
                eventName: 'page_completed',
                data: {
                    page_number: quizScreenFromUrl,
                    answer,
                    question,
                },
            });
            setActiveAnswer('');
            setIsAnimate(true);
        }, 500);
    };

    return (
        <section className="question_screen">
            <Header
                logoUrl={logoUrl}
                lengthOnboarding={lengthOnboarding}
                handleSwitchToPrevScreen={handleSwitchToPrevScreen}
                logoLink={logoLink}
            />
            <div className="question_screen__wrapper">
                {title && <h2 className="question_screen__title" dangerouslySetInnerHTML={{ __html: title }} />}
                {answers && (
                    <div className="question_screen__item-wrap">
                        {answers.map((item) => {
                            const isActiveAnswer = activeAnswer === item;

                            return (
                                <button
                                    type="button"
                                    key={item}
                                    className={classNames('question_screen__item', {
                                        'question_screen__item--active': isActiveAnswer,
                                        'question_screen__item--animated': isAnimate,
                                    })}
                                    style={{
                                        color: `${hexToRGB(themColor, `${isActiveAnswer ? '.9' : '.7'}`)}`,
                                        borderColor: `${hexToRGB(themColor, `${isActiveAnswer ? '.9' : '0'}`)}`,
                                    }}
                                    onClick={() => {
                                        handleClick(item);
                                    }}
                                >
                                    <span className="question_screen__check">
                                        <span
                                            style={{
                                                background: `${hexToRGB(themColor, `${isActiveAnswer ? '.9' : '0'}`)}`,
                                            }}
                                        />
                                    </span>
                                    {item}
                                </button>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default QuestionScreen;
